/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Reset_Variables_Partial_ErrorInputs */



/**
* | output |
* | --- |
* | "{count} module(s) did not acknowledge the initialization." |
*
* @param {Reset_Variables_Partial_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reset_variables_partial_error = /** @type {((inputs: Reset_Variables_Partial_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Variables_Partial_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.count} module(s) did not acknowledge the initialization.`)
	return /** @type {LocalizedString} */ (`${i?.count} module(s) n'ont pas confirmé l'initialisation.`)
});